import {
  SET_SPARE_PARTS_ORDERING,
  SET_SPARE_PARTS_RECEPTION,
  SET_SPARE_PARTS_FOR_MATCHING
} from '../constants'

const initialState = {
  sparePartsOrdering: [],
  sparePartsCommentsOrdering: [],
  sparePartsFilterOrdering: {},
  sparePartsReception: [],
  sparePartsCommentsReception: [],
  sparePartsFilterReception: {},
  sparePartsForMatching: []
}

export default (state = initialState, action) => {
  let res = { ...state }
  switch (action.type) {
    case SET_SPARE_PARTS_ORDERING:
      res.sparePartsOrdering = action.payload.spareParts
      res.sparePartsCommentsOrdering = action.payload.comments
      if (action.payload.filter != null) res.sparePartsFilterOrdering = action.payload.filter
      return res
    case SET_SPARE_PARTS_RECEPTION:
      res.sparePartsReception = action.payload.spareParts
      res.sparePartsCommentsReception = action.payload.comments
      if (action.payload.filter != null) res.sparePartsFilterReception = action.payload.filter
      return res
    case SET_SPARE_PARTS_FOR_MATCHING:
      res.sparePartsForMatching = action.payload.spareParts
      return res
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/spareparts.js